(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-product-advantages"] && !Shopify.designMode) return;
  try {
    (function(){
  const observer=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.querySelectorAll('.pi-bar__fill').forEach(el=>{
          const t=el.style.getPropertyValue('--target');
          el.style.width='calc('+t+' - 6px)';
        });
        observer.unobserve(e.target);
      }
    });
  },{root:null,threshold:0,rootMargin:'0px 0px -150px 0px'});
  document.querySelectorAll('.progress-image-snippet').forEach(s=>observer.observe(s));
})();
  } catch(e) { console.error(e); }
})();

})();
